import produce from "immer";
import { LoadState } from "../../../constants/enums";
import {
  ISeedBalancesState,
  initialSeedBalancesState,
} from "./SeedBalances.types";
import { SeedBalancesActions } from ".";
import {
  CLEAR_SEED_BALANCES_STATE,
  FETCH_SEED_BALANCES_GRID_FAILED,
  FETCH_SEED_BALANCES_GRID_PROGRESS,
  FETCH_SEED_BALANCES_GRID_SUCCESS,
  FETCH_SEED_BALANCES_HISTORY_FAILED,
  FETCH_SEED_BALANCES_HISTORY_PROGRESS,
  FETCH_SEED_BALANCES_HISTORY_SUCCESS,
  SAVE_SEED_BALANCES_FAILED,
  SAVE_SEED_BALANCES_PROGRESS,
  SAVE_SEED_BALANCES_SUCCESS,
} from "./SeedBalancesActions";

export const seedBalancesReducer = (
  state: ISeedBalancesState = initialSeedBalancesState,
  action: SeedBalancesActions
) => {
  switch (action.type) {
    // ========================================================================
    // Grid
    // ========================================================================
    case FETCH_SEED_BALANCES_GRID_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.grid = [];
        draftState.loading = LoadState.InProgress;
        draftState.error = null;
      });
      return newState;
    }

    case FETCH_SEED_BALANCES_GRID_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.grid = data;
        draftState.error = null;
      });
      return newState;
    }

    case FETCH_SEED_BALANCES_GRID_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.grid = [];
        draftState.loading = LoadState.Failed;
      });
      return newState;
    }

    // ========================================================================
    // Save
    // ========================================================================
    case SAVE_SEED_BALANCES_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.saveLoading = LoadState.InProgress;
        draftState.error = null;
      });
      return newState;
    }

    case SAVE_SEED_BALANCES_SUCCESS: {
      const newState = produce(state, (draftState) => {
        draftState.saveLoading = LoadState.Loaded;
        draftState.error = null;
      });
      return newState;
    }

    case SAVE_SEED_BALANCES_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.saveLoading = LoadState.Failed;
      });
      return newState;
    }

    // ========================================================================
    // History
    // ========================================================================
    case FETCH_SEED_BALANCES_HISTORY_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.history = [];
        draftState.historyLoading = LoadState.InProgress;
        draftState.error = null;
      });
      return newState;
    }

    case FETCH_SEED_BALANCES_HISTORY_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.historyLoading = LoadState.Loaded;
        draftState.history = data;
        draftState.error = null;
      });
      return newState;
    }

    case FETCH_SEED_BALANCES_HISTORY_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.history = [];
        draftState.historyLoading = LoadState.Failed;
      });
      return newState;
    }

    // ========================================================================
    // Clear
    // ========================================================================
    case CLEAR_SEED_BALANCES_STATE: {
      return initialSeedBalancesState;
    }

    default:
      return state;
  }
};
